export enum OrderReceiptItemType {
  PRODUCT = 'product',
  DESIGN = 'design',
  OPTION = 'option',
  TAX = 'tax',
  DIGITIZATION_FEE = 'digitization',
}
